import React from 'react';
import PropTypes from 'prop-types';

import { readCookie } from '../../../../../../../src/utils/readCookie';
import reportException from '../../../../../../../shared/lib/report-exception';
import { setNonPersonalizedAds, userHasOptedIntoPersonalizedAds } from '../../../../../../../shared/lib/google-global-site-tag/index';

export default class AdsInitialSettings extends React.Component {
  static propTypes = {
    cookieName: PropTypes.string,
    isInEEA: PropTypes.bool,
    reportPersonalizedAds: PropTypes.func,
    user: PropTypes.object,
  }

  componentDidMount() {
    this.shouldShowPersonalizedAds();
  }

  shouldComponentUpdate() {
    return false;
  }

  setAdsPref = (bool) => {
    const { isInEEA, reportPersonalizedAds } = this.props;
    if (!bool) {
      // optd out :^(
      setNonPersonalizedAds(1);
      reportPersonalizedAds(true);
    } else {
      // they opted in
      setNonPersonalizedAds(0);
      reportPersonalizedAds(false);
      if (typeof googletag !== 'undefined' && isInEEA && googletag.pubads) {
        googletag.pubads().refresh();
      }
    }
  }

  shouldShowPersonalizedAds = () => {
    const { cookieName, user } = this.props;
    try {
      if (!user) {
        // default in EU is to show non personalized ads unless explicit opt in
        const cookieVal = readCookie({
          name: cookieName,
        });

        // user may want personalized ads so check out the cookie
        if (cookieVal === 'false') {
          this.setAdsPref(false);
        } else {
          this.setAdsPref(true);
        }
      } else {
        // user exists so lets check to see that they have poted in to see personalized ads
        const optInPersonalizedAds = userHasOptedIntoPersonalizedAds(user);
        this.setAdsPref(optInPersonalizedAds);
      }
    } catch (err) {
      reportException(err, {}, 'EUCompliance-component-googletag-commands');
    }
  }

  isTrueSet = val => (val === 'true');

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./modules/App/components/children/EUCompliance/children/AdsInitialSettings/AdsInitialSettings.js